<template>
    <div id="body-wrap">
        <LayoutHeader title="실시간 도시 현황" color="bg-red">
            <ul slot="navigator" class="category_list">
                <li>홈</li>
                <li>실시간도시현황</li>
            </ul>
        </LayoutHeader>
        <Realtime />
    </div>
</template>

<script>
import { $WC } from "@/conf/common.const";
import LayoutHeader from '@/views/layout/LayoutHeader.vue';
import Realtime from '@/views/realtime/Realtime.vue';

export default {
  name: 'RealtimeApp',
  created() {
      // 재난 안전 (5분 마다 조회)
      this.$store.dispatch('FETCH_SAFETY_LIST');
      setInterval(() => {
          this.$store.dispatch('FETCH_SAFETY_LIST');
      }, $WC.FIVE_MIN_INTERVAL);

      // 돌발 상황(5분 마다 조회)
      this.$store.dispatch('FETCH_ACCIDENT_LIST');
      setInterval(() => {
          this.$store.dispatch('FETCH_ACCIDENT_LIST');
      }, $WC.FIVE_MIN_INTERVAL);

      // 코로나 현황
      this.$store.dispatch('FETCH_COVID_STATE');
      // 코로나 접종 현황
      this.$store.dispatch('FETCH_LATEST_VACCINATION');

      // 자치구 대기 정보 (10분 마다 조회)
      /*
      this.$store.dispatch('FETCH_AIR_GU');
      setInterval(() => {
          this.$store.dispatch('FETCH_AIR_GU');
      }, AIR_INTERVAL);
      */

      // 날씨정보 (10분 마다 조회)
      this.$store.dispatch('FETCH_AIRSPACE');
      setInterval(() => {
          this.$store.dispatch('FETCH_AIRSPACE');
      }, $WC.TEN_MIN_INTERVAL);

      // 행정동 대기 정보 (10분 마다 조회)
      this.$store.dispatch('FETCH_AIR_HJD_LIST');
      setInterval(() => {
          this.$store.dispatch('FETCH_AIR_HJD_LIST');
      }, $WC.TEN_MIN_INTERVAL);

      // 상수도 수질 정보
      this.$store.dispatch('FETCH_LASTEST_WATER_QUALITY_LIST');
      setInterval(() => {
          this.$store.dispatch('FETCH_LASTEST_WATER_QUALITY_LIST');
      }, $WC.TEN_MIN_INTERVAL);

      // 배수지 정보
      this.$store.dispatch('FETCH_WATER_RESERVOIR_LIST');
      // 수도꼭지 정보
      this.$store.dispatch('FETCH_WATER_FAUCET_LIST');
      // 물길 정보 목록
      this.$store.dispatch('FETCH_WATER_ROAD_LIST');
  },
  components: {
      LayoutHeader,
      Realtime
  }
}
</script>
